import axios from 'axios';
import { getPublicAccessToken, clearPublicToken } from './publicToken';

const http = axios.create({
  baseURL: 'https://xibb6u88vd.execute-api.us-west-2.amazonaws.com/dev',
  headers: { 'Content-Type': 'application/json' }
});

let isRefreshing = false;
let queue = [];
const subscribe = (cb) => queue.push(cb);
const flush = (t) => { queue.forEach(cb => cb(t)); queue = []; };

http.interceptors.request.use(async (config) => {
  const token = await getPublicAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error || {};
    if (!response) return Promise.reject(error);
    if (response.status !== 401 || config._retry) return Promise.reject(error);

    config._retry = true;

    if (!isRefreshing) {
      isRefreshing = true;
      try {
        clearPublicToken();                    // force a new token
        const t = await getPublicAccessToken();// fetch once
        isRefreshing = false;
        flush(t);
      } catch (e) {
        isRefreshing = false;
        return Promise.reject(e);
      }
    }

    // queue waiting requests until refresh completes
    return new Promise((resolve) => {
      subscribe((token) => {
        if (token) config.headers.Authorization = `Bearer ${token}`;
        resolve(http(config));
      });
    });
  }
);

export default http;